import { render, staticRenderFns } from "./LanguagesSelector.vue?vue&type=template&id=728e4ee8&"
import script from "./LanguagesSelector.vue?vue&type=script&lang=js&"
export * from "./LanguagesSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports